import { useEffect, useState } from 'react';
import { Dimensions } from 'react-native';

export const useScreenWidth = () => {
  const [width, setWidth] = useState(Dimensions.get('window').width);

  useEffect(() => {
    const onChange = ({ window }) => setWidth(window.width);
    const subscription = Dimensions.addEventListener('change', onChange);
    return () => subscription?.remove?.();
  }, []);

  return width;
};

export const useAutoScrollOnWidthChange = (screenWidth, scrollRef, multiplier = 0.5) => {
  useEffect(() => {
    const offset = screenWidth * multiplier;
    if (scrollRef.current) {
      scrollRef.current.scrollTo({ x: offset, animated: true });
    }
  }, [screenWidth]);
}
